/**
 * 
 */
import * as mapvgl from 'mapvgl'
import AppMap from '@/components/screen28896/map-zone/AppMap.js'
import geoTowns from '@/components/geo-towns.js'
import {
  listEnterpriseGeoOfTown
} from '@/api/enterprise.js'

function ControlMap() {
  var vue
  /**
   * 显示某个乡镇，具体会展示乡镇内所有企业的种植面积
   * @param {*} v 
   * @param {*} code 
   */
  this.start = function (v, code) {
    vue = v
    const {
      map,
      view
    } = AppMap
    const f = JSON.parse(JSON.stringify(geoTowns.features.find((current, index, arr) => {
      return current.properties.Code === code
    })))
    vue.setName(f.properties.Name)
    vue.setDesc(f.properties.Des)
    AppMap.fly2(117.1900, 32.4566, 16.9, {
      tilt: 50,
      heading: -36
    }).then(() => {
      listEnterpriseGeoOfTown(code).then(enterprises => {
        const features = []
        const labels = []
        enterprises.forEach(e => {
          // 组装features
          const coordinates = []
          e.bound.push(e.bound[0])
          e.bound.forEach(b => {
            coordinates.push([b.lng, b.lat])
          })
          features.push({
            type: 'Feature',
            geometry: {
              type: 'Polygon',
              coordinates: [
                coordinates
              ]
            },
            properties: {
              id: e.id
            }
          })
          // 填加标注
          const {
            lng,
            lat
          } = e.center
          const lbl = new BMapGL.Label(
            ` <p class="enterprise-name">${e.title}</p>`, {
              position: new BMapGL.Point(lng, lat),
              offset: new BMapGL.Size(0, -20)
            })
          lbl.setStyle({
            borderColor: 'rgba(0,0,0,0)',
            backgroundColor: 'rgba(0,0,0,0)',
          })
          labels.push(lbl)
        })
        // 企业园区地面
        const landLyr = new mapvgl.PolygonLayer({
          //cf1505
          fillColor: '#106000', // 填充颜色
          lineWidth: 0,
          enablePicked: true, // 是否可以拾取
          selectedIndex: -1, // 选中项
          selectedColor: '#788400', // 选中项颜色
          autoSelect: true, // 根据鼠标位置来自动设置选中项
          onClick: (e) => {
            if (e && e.dataItem) {
              vue.$router.push(`/screen28896/parks/${code}/${e.dataItem.properties.id}`)
            }
          }
        })
        view.addLayer(landLyr)
        landLyr.setData(features)
        // 企业园区边界
        const wallLyr = new mapvgl.WallLayer({
          gradient: {
            1: 'rgba(71, 179, 50,1)',
            0: 'rgba(91, 199, 70, 0.9)'
          },
          height: 25
        })
        view.addLayer(wallLyr)
        wallLyr.setData(features)
        //
        labels.forEach(lbl => {
          map.addOverlay(lbl)
        })

      }) // listEnterpriseOfTown()
    })
  }

  /**
   * 销毁之前绘制的所有内容，通常在页面切换时调用
   */
  this.destroy = function () {
    const {
      map,
      view
    } = AppMap
    view.removeAllLayers()
    map.clearOverlays()
  }
}

export default new ControlMap()



// WEBPACK FOOTER //
// ./src/components/screen28896/map-zone/mask/ControlMap.js